<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
        <div class="container">
            <div class="row p-5 text-center">
                <p class="title">{{ translate.text1 }}</p>
                <p class="text" v-html="translate.text2"></p>
                <p class="text">{{ options.userName ?? '' }}, {{ translate.text10 }}</p>
                <p class="text">{{ translate.text4 }}</p>
                <p class="text">{{ translate.text5 }}</p>
                <!-- <p class="text">{{ translate.text6 }} {{ options.planName }}</p> -->
                <p class="text">
                    {{ translate.text12 }}
                    <router-link :to="{ name: 'MyCreditsPage', params: { locale } }">
                        <span style="color:#b20000">{{ translate.text11 }}</span>
                    </router-link>        
                </p>                
            </div>
        </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/checkoutsuccess'
import { userStore } from 'stores/user'

export default defineComponent({
  name: 'CheckoutSuccessView',
  //props: ['options'],  
  computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(userStore, ['user']),
      translate: function () {
          if (this.locale === 'pt-br') {
              return tradutor.portugues
          } else {
              return tradutor.ingles
          }
      }
  },
  mounted () {
    this.options.userName = this.user.name ? this.user.name : this.translate.text9
  },
  data() {
    return {
        options: {
            userName: '',
            planName: 'Plano Teste 2024'
        }
    }
  },
})
</script>

<style scoped lang="css">

.slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
    font-size: 20px;
}

.title {
    margin-top: 30px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.text {
    margin-top: 10px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 25px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

}
</style>
